import { render } from "./CRP.vue?vue&type=template&id=1985a5d0&ts=true"
import script from "./CRP.vue?vue&type=script&lang=ts"
export * from "./CRP.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__